import React from "react";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import { main } from "assets";
import TileWrapper from "./TileWrapper";
import Header from "./Header";
import TileBody from "./TileBody";

function FeedbackAndSupportTile(props) {
  return (
    <TileWrapper>
      <Link to={"/userhome/feedback_and_support"}>
        <Header title={props.messages.label[props.locale]} />
        <TileBody img={main.feedbackAndSupport} alt={"feedback and support"} />
      </Link>
    </TileWrapper>
  );
}

const mapStateToProps = (state) => {
  const { messages, locale } = state.intl;
  return {
    locale,
    messages: {
      label: messages.containers.main.feedbackAndSupport.main.name,
    },
  };
};

export default connect(mapStateToProps, null)(FeedbackAndSupportTile);
